export function apiErrorMessage(error, fallback) {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    const messages = detail.map(item => item?.msg).filter(message => typeof message === 'string');
    if (messages.length) return messages.map(message => message.replace(/^Value error, /, '')).join(' ');
  }
  if (typeof detail?.message === 'string') return detail.message;
  if (error?.code === 'ECONNABORTED' || error?.code === 'ETIMEDOUT') {
    return 'The server is taking longer than expected. Please try again in a moment.';
  }
  return fallback;
}
